<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Status
              </td>
              <td>
                <app-drop-down
                  type="status"
                  [settings]="dropdownSettingsBookType"
                  [list]="dropdownListStatus"
                  (dropDownChanged)="updateSelectedType($event)"
                  [selectedItems]="selectedDefaultItemsStatus"
                ></app-drop-down>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Book Type
              </td>
              <td>
                <app-drop-down
                  type="bookType"
                  [settings]="dropdownSettingsBookType"
                  [list]="listBookType"
                  (dropDownChanged)="updateSelectedType($event)"
                  [selectedItems]="selectedDefaultBookType"
                ></app-drop-down>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Product Type
              </td>
              <td>
                <app-drop-down
                  type="productType"
                  [settings]="dropdownSettingsBookType"
                  [list]="listProductType"
                  (dropDownChanged)="updateSelectedType($event)"
                  [selectedItems]="selectedDefaultProductType"
                ></app-drop-down>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                PPD
              </td>
              <td>
              <app-drop-down-single-select
                [DropDownOptions]="dateOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'ppdOption'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="ppd"
                (dateSelected)="updateSelectedType($event)"
              ></app-date-select>
            </td>
            </tr>
            <tr>
            <td>Published Date</td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="dateOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'publishedDateOption'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="publishedDate"
                (dateSelected)="updateSelectedType($event)"
              ></app-date-select>
            </td>
          </tr>
            <tr>
              <td class="v-align-m">
                Contracted Date
              </td>
              <td>
              <app-drop-down-single-select
                [DropDownOptions]="dateOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'contractedDateOption'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="contractedDate"
                (dateSelected)="updateSelectedType($event)"
              ></app-date-select>
            </td>
            </tr>
            <tr>
              <td class="v-align-m">
                User Email
              </td>
              <td colspan="2">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="userEmail"
                  placeholder=""
                />
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Product ID
              </td>
              <td colspan="2">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="productId"
                  placeholder=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div class="container mt-3">
  <div class="card">
    <div class="card-body" style="font-size: 12px;">
      <p>
        To view all data, please remove name from User field and click search.
        <br />
        After clicking reset, It will reset the filter and data
      </p>
    </div>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product ID</th>
          <th scope="col">ISBN-13P</th>
          <th scope="col">Title</th>
          <th scope="col">Book Type</th>
          <th scope="col">Chapter Status</th>
          <th scope="col">Product Status</th>
          <th scope="col">Devcon1 Status</th>
          <th scope="col">Devcon2 Status</th>
          <th scope="col">Expected Page Count</th>
          <th scope="col">Actual Page Count</th>
          <th scope="col">Product Information Status</th>
          <th scope="col">Chapter Number</th>
          <th scope="col">Chapter Name</th>
          <th scope="col">Handover to Production Date</th>
          <th scope="col">TE</th>
          <th scope="col">LC</th>
          <th scope="col">PD</th>
          <th scope="col">Indexer</th>
          <th scope="col">Content Engineer</th>
          <th scope="col">PM</th>
          <th scope="col">Publisher</th>
          <th scope="col">Original Preliminary Draft DUE Date</th>
          <th scope="col">Preliminary Draft Expected Date</th>
          <th scope="col">Preliminary Draft Received Date</th>
          <th scope="col">Preliminary Draft Accepted Date</th>
          <th scope="col">Original Final Draft DUE Date</th>
          <th scope="col">Final Draft Expected Date</th>
          <th scope="col">Final Draft Received Date</th>
          <th scope="col">Final Draft Accepted Date</th>
          <th scope="col">TE First Pass Completed Date</th>
          <th scope="col">Copy Editing Complete Date</th>
          <th scope="col">TE Signed Off Date</th>
          <th scope="col">Indexing Complete Date</th>
          <th scope="col">Layout Complete Date</th>
          <th scope="col">Proofing Complete Date</th>
          <th scope="col">PR-TE Checks Complete Date</th>
          <th scope="col">Prefinals Complete Date</th>
          <th scope="col">Prefinals Sent Out Date</th>
          <th scope="col">Prefinals Received Date</th>
          <th scope="col">Author-TE Checks Complete Date</th>
          <th scope="col">Finals Done</th>
          <th scope="col">EDD</th>
          <th scope="col">EPD</th>
          <th scope="col">PPD</th>
          <th scope="col">Published Date</th>
          <th scope="col">Drop Dead Publication Date</th>
          <th scope="col">Product Type</th>
          <th scope="col">Chapter Link</th>
          <th scope="col">Chapter Id</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.part_number}}</td>
          <td>{{product.isbn_13}}</td>
          <td>{{product.product_name}}</td>
          <td>{{product.book_type}}</td>
          <td>{{product.chapter_status}}</td>
          <td>{{product.product_status}}</td>
          <td>{{product.devcon1_status}}</td>
          <td>{{product.devcon2_status}}</td>
          <td>{{product.expected_page_count}}</td>
          <td>{{product.actual_page_count}}</td>
          <td>{{product.pistatus}}</td>
          <td>{{product.chapter_number}}</td>
          <td>{{product.chapter_name}}</td>
          <td>{{product.handover_to_production_date}}</td>
          <td>{{product.TE}}</td>
          <td>{{product.LC}}</td>
          <td>{{product.PD}}</td>
          <td>{{product.Indexer}}</td>
          <td>{{product.Content_Engineer}}</td>
          <td>{{product.PM}}</td>
          <td>{{product.Publisher}}</td>
          <td>{{product.pd_overdue_date}}</td>
          <td>{{product.pd_expected_date}}</td>
          <td>{{product.pd_received_date}}</td>
          <td>{{product.pd_accepted_date}}</td>
          <td>{{product.fd_overdue_date}}</td>
          <td>{{product.fd_expected_date}}</td>
          <td>{{product.fd_received_date}}</td>
          <td>{{product.fd_accepted_date}}</td>
          <td>{{product.tech_editing_complete}}</td>
          <td>{{product.copy_editing_complete}}</td>
          <td>{{product.te_sign_off_complete}}</td>
          <td>{{product.indexing_complete}}</td>
          <td>{{product.layout_complete_date}}</td>
          <td>{{product.proofing_complete}}</td>
          <td>{{product.te_checks_complete_date}}</td>
          <td>{{product.prefinals_complete}}</td>
          <td>{{product.prefinals_sent_out}}</td>
          <td>{{product.prefinals_received}}</td>
          <td>{{product.final_checks_complete_date_c}}</td>
          <td>{{product.finals_done}}</td>
          <td>{{product.edd}}</td>
          <td>{{product.epd}}</td>
          <td>{{product.ppd}}</td>
          <td>{{product.publishing_date}}</td>
          <td>{{product.drop_dead_dte_c}}</td>
          <td>{{product.product_type}}</td>
          <td>{{product.sharepoint_chapter_link}}</td>
          <td>{{product.chapter_id}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
